import LegalPage from "@/components/LegalPage";

export default function CGV() {
  return (
    <LegalPage title="Conditions Générales de Vente" updatedAt="2026-02-15 (version 2026-02-15)" testid="page-cgv">
      <h2>Préambule — Service exclusivement destiné aux professionnels</h2>
      <p>
        RevenueFix AI est un service SaaS d'audit e-commerce destiné <strong>exclusivement aux
        professionnels</strong> agissant à des fins entrant dans le cadre de leur activité
        professionnelle, notamment les exploitants de boutiques e-commerce. En souscrivant, le
        client confirme sa qualité de professionnel. Le service n'est pas destiné aux consommateurs
        au sens du Code de la consommation.
      </p>

      <h2>1. Objet et parties</h2>
      <p>
        Les présentes Conditions Générales de Vente (CGV) régissent la souscription aux abonnements
        payants de RevenueFix AI (le « Service »).
      </p>
      <p>
        L'éditeur du Service (le « Prestataire ») est :<br />
        <strong>VALQORY</strong> — Entrepreneur individuel (micro-entreprise)<br />
        SIREN : 109 877 399 — SIRET : 109 877 399 00013<br />
        Adresse professionnelle : 17 Place Charles Albert, 73250 Saint-Pierre-d'Albigny, France<br />
        Email : <a href="mailto:damienallais3@gmail.com">damienallais3@gmail.com</a>
      </p>
      <p>
        Le « Client » est le professionnel qui souscrit un abonnement au Service.
      </p>

      <h2>2. Acceptation et qualification professionnelle</h2>
      <p>
        Avant tout paiement, le Client confirme explicitement, via une case à cocher non pré-cochée :
      </p>
      <blockquote className="border-l-2 border-violet-500/50 pl-3 italic text-slate-300">
        « Je confirme souscrire à RevenueFix AI en qualité de professionnel et utiliser le service
        à des fins entrant dans le cadre de mon activité professionnelle. J'accepte les Conditions
        Générales de Vente. »
      </blockquote>
      <p>
        Cette confirmation est <strong>obligatoire</strong> pour poursuivre vers le paiement.
        La preuve de cette acceptation (identifiant Client, version des CGV, date et heure,
        adresse IP, agent utilisateur) est conservée par le Prestataire à des fins probatoires.
      </p>

      <h2>3. Forfaits et quotas</h2>
      <ul>
        <li><strong>Free</strong> — 0 € — 1 audit / 30 jours.</li>
        <li><strong>Pro</strong> — 19,90 € / mois — jusqu'à 250 audits / 30 jours, rapport complet, export PDF.</li>
        <li>
          <strong>Agency</strong> — 79 € / mois — jusqu'à 1 000 audits / 30 jours, jusqu'à 15 boutiques,
          rapports en marque blanche, accès API et webhooks, support prioritaire.
        </li>
      </ul>
      <p>
        Le quota est calculé <strong>par compte</strong> sur une fenêtre glissante de 30 jours.
        Lorsque le quota est atteint, la création de nouveaux audits est bloquée jusqu'au
        renouvellement de la période. Les rapports et exports existants restent accessibles.
      </p>

      <h2>4. Prix et facturation</h2>
      <p>
        Les prix affichés sont exprimés en euros. Le Prestataire exerçant sous le régime de la
        micro-entreprise, la mention « TVA non applicable, art. 293 B du CGI » est portée sur les
        factures tant que ce régime demeure applicable. Si la TVA devient applicable, les prix
        affichés seront ajustés en conséquence conformément aux règles fiscales en vigueur.
      </p>
      <p>
        L'abonnement est <strong>mensuel</strong> et se renouvelle automatiquement chaque mois par
        prélèvement via Stripe, jusqu'à résiliation. La facturation intervient à la date anniversaire
        de la souscription.
      </p>

      <h2>5. Exécution du service</h2>
      <p>
        L'accès au Service payant démarre <strong>immédiatement</strong> après le paiement.
      </p>

      <h2>6. Résiliation</h2>
      <p>
        Le Client peut <strong>résilier à tout moment</strong> son abonnement depuis l'espace
        « Gérer mon abonnement » (portail Stripe). La résiliation prend effet à la fin de la
        période mensuelle déjà payée : l'accès aux fonctionnalités payantes est maintenu jusqu'à
        cette échéance, puis le compte repasse automatiquement au forfait Free. Aucun prélèvement
        supplémentaire n'a lieu après la résiliation.
      </p>

      <h2>7. Remboursements</h2>
      <p>
        Une résiliation seule <strong>n'entraîne pas automatiquement</strong> le remboursement de
        la période mensuelle en cours, celle-ci ayant déjà été facturée et le Service étant
        pleinement disponible jusqu'à son échéance.
      </p>
      <p>
        Aucune clause des présentes ne saurait toutefois écarter une disposition légale impérative
        éventuellement applicable. Les cas particuliers (facturation erronée, panne majeure
        prolongée) peuvent faire l'objet d'un examen sur demande adressée à
        <a href="mailto:damienallais3@gmail.com"> damienallais3@gmail.com</a>.
      </p>

      <h2>8. Suspension et non-suppression des données</h2>
      <p>
        Les audits, rapports et exports PDF déjà générés <strong>ne sont pas supprimés</strong> en
        cas d'atteinte du quota, de changement de forfait ou de résiliation. Ils restent
        accessibles depuis le tableau de bord dans les limites de conservation prévues à la
        Politique de confidentialité.
      </p>

      <h2>9. Modifications du service et des CGV</h2>
      <p>
        Le Prestataire peut faire évoluer le Service et les présentes CGV. Toute modification
        substantielle sera communiquée aux Clients actifs. La version des CGV acceptée par le
        Client est <strong>tracée côté serveur</strong> (identifiant Client, version, horodatage).
      </p>

      <h2>10. Données personnelles</h2>
      <p>
        Voir la <a href="/legal/confidentialite">Politique de confidentialité</a>.
      </p>

      <h2>11. Droit applicable</h2>
      <p>
        Les présentes CGV sont régies par le <strong>droit français</strong>. Les parties étant
        des professionnels, elles conviennent de rechercher une solution amiable avant tout
        contentieux. À défaut, les tribunaux compétents seront désignés conformément aux règles
        de droit commun applicables aux contrats conclus entre professionnels.
      </p>
    </LegalPage>
  );
}
